import { Programme, ProgrammeType } from 'src/@types/programme';
import useMerchant from './useMerchant';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { useCallback, useMemo } from 'react';
import { TransactionOwnershipType } from 'src/resources/api/purchase/types.api';

//
//

export const useProgramme = (programmeCode?: string | null) => {
  const { merchant, isMerchantLoading } = useMerchant();

  const programme = merchant?.programmes?.find((programme) => programme?.code === programmeCode);

  const getProgrammeLink = useCallback((purchase?: any) => {
    if (!purchase?.id) return '';
  
    const programme = merchant?.programmes?.find((p: Programme) => p?.code === purchase?.programmeCode);
  
    if (purchase?.programmeCode && programme?.type) {
      return PATH_DASHBOARD.programs.transaction(programme?.type.toLowerCase(), purchase?.programmeCode, purchase?.id)
    } else {
      return PATH_DASHBOARD.offsets.transaction(purchase.id)
    }
  }, [merchant?.programmes]);

  // TODO: Remove temporal fix when backend handles ownership types by itself
  const ownershipTypeBasedOnProgrammeType: TransactionOwnershipType[] = useMemo(() => {
    switch (programme?.type) {
      case ProgrammeType.MYCARBONCLICK:
        return [TransactionOwnershipType.CUSTOMER];
      case ProgrammeType.MANAGED:
      case ProgrammeType.CUSTOMER:
        return [TransactionOwnershipType.CUSTOMER, TransactionOwnershipType.MERCHANT];
      default:
        return []
    }
  }, [programme?.type]);

  //

  return {
    programme,
    isMerchantLoading,
    programmes: merchant?.programmes,
    getProgrammeLink,
    ownershipTypeBasedOnProgrammeType,
  };
};
